import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PageLayoutComponent } from '../../components/page-layout/page-layout.component';

@Component({
  standalone: true,
  selector: 'app-about',
  templateUrl: './about.component.html',
  // imports: [RouterLink],
  imports: [PageLayoutComponent],
  styleUrl: './about.component.scss',
})
export class AboutComponent {
  toolName = 'MAQI';
  toolDescriptor = 'MPC Advanced Queries Interface';
}
